import {
  PAY_DEBT_TO_DRIVER,
  PAY_DRIVER_DEBT_BY_CHECK_MARK,
  PAY_OFFLINE,
} from "../../routes";
import customAxios from "../../customAxios";
import { IPayDriverFactors } from "../../../types/common.interface";

async function payDriverDebtByCheckMark(props: IPayDriverFactors) {
  const thisUrl = PAY_DRIVER_DEBT_BY_CHECK_MARK+"/"+props.driverId;

  let body: IPayDriverFactors = {
    fishId: props.fishId,
    factorList: props.factorList,
    offlinePayType: props.offlinePayType,
    amount: props.amount,
    startAt: props.startAt,
    // payerType: props.payerType,
  };

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ PAY_DEBT_TO_DRIVER: error });
  }
}

export default payDriverDebtByCheckMark;
